@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              @if(column.key.convertClient && !spinLoad.convertClient){
                @if(element.subCliente == 'S' || element.subCliente ==  'A'){
                  <mat-icon
                    class="btn-icon-outline disabled"
                    fontIcon="supervised_user_circle"
                  />
                }@else{
              <mat-icon
                class="btn-icon-outline"
                fontIcon="supervised_user_circle"
                matTooltip="Virar subcliente"
                (click)="convertClientItemEvent(element)"
              />
                }
              } @else if(column.key.convertClient && spinLoad.convertClient){
              <mat-spinner
                diameter="24"
              ></mat-spinner>
              }

              @if(column.key.convertSubClient && !spinLoad.convertSubClient){
                @if(element.subCliente ==  'A'){
                  <mat-icon
                    class="btn-icon-outline disabled"
                    fontIcon="supervised_user_circle"
                  />
                }@else{
              <mat-icon
                class="btn-icon-outline"
                fontIcon="supervised_user_circle"
                matTooltip="Virar cliente"
                (click)="convertSubClientItemEvent(element)"
              />
                }
              } @else if(column.key.convertSubClient && spinLoad.convertSubClient){
              <mat-spinner
                diameter="24"
              ></mat-spinner>
              }

              @if(column.key.convertToSupplier && !spinLoad.convertToSupplier){
                @if(element.jaEhFornecedor){
                  <mat-icon
                    class="btn-icon-outline disabled"
                    fontIcon="local_shipping"
                    matTooltip="Já cadastrado como fornecedor"
                  />
                }@else{
              <mat-icon
                class="btn-icon-outline"
                fontIcon="local_shipping"
                matTooltip="Virar fornecedor"
                (click)="convertToSupplierItemEvent(element)"
              />
                }
              } @else if(column.key.convertToSupplier && spinLoad.convertToSupplier){
              <mat-spinner
                diameter="24"
              ></mat-spinner>
              }

              @if(column.key.convertToClient && !spinLoad.convertToClient){
                @if(element.jaEhCliente){
                  <mat-icon
                    class="btn-icon-outline disabled"
                    fontIcon="badge"
                    matTooltip="Já cadastrado como cliente"
                  />
                }@else{
              <mat-icon
                class="btn-icon-outline"
                fontIcon="badge"
                matTooltip="Virar cliente"
                (click)="convertToClientItemEvent(element)"
              />
                }
              } @else if(column.key.convertToClient && spinLoad.convertToClient){
              <mat-spinner
                diameter="24"
              ></mat-spinner>
              }


              @if(element.statusId && element.statusId != 2 && element.statusId != 5){
              <mat-icon
                *ngIf="column.key.cancelContract && !spinLoad.cancelContract"
                class="btn-icon-outline"
                fontIcon="restore_page"
                matTooltip="Cancelar Contrato"
                (click)="cancelContractEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.cancelContract && spinLoad.cancelContract"
                diameter="24"
              ></mat-spinner>
              }

              <mat-icon
                *ngIf="column.key.active && !spinLoad.active && element?.ativo"
                class="cursor-pointer"
                [ngClass]="
                  element.ativo.toLowerCase() == 's'
                    ? 'btn-icon-toogle-on'
                    : 'btn-icon-toogle-off'
                "
                [fontIcon]="
                  element.ativo.toLowerCase() == 's'
                    ? 'toggle_on'
                    : 'toggle_off'
                "
                [matTooltip]="
                  element.ativo.toLowerCase() == 's' ? 'Ativado' : 'Desativado'
                "
                (click)="activeEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.active_management && !spinLoad.active && element?.usuario_status && !element.isUsuario"
                class="cursor-pointer"
                [ngClass]="
                  element.usuario_status == 1
                    ? 'btn-icon-toogle-on'
                    : 'btn-icon-toogle-off'
                "
                [fontIcon]="
                  element.usuario_status == 1
                    ? 'toggle_on'
                    : 'toggle_off'
                "
                [matTooltip]="
                element.usuario_status == 1 ? 'Ativado' : 'Desativado'
                "
                (click)="activeEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.active_management && !spinLoad.active && element?.isUsuario === 'S'"
                class="cursor-pointer"
                [ngClass]="
                  element?.usuario_status == 1
                    ? 'btn-icon-toogle-on'
                    : 'btn-icon-toogle-off'
                "
                [fontIcon]="
                  element?.usuario_status == 1
                    ? 'toggle_on'
                    : 'toggle_off'
                "
                [matTooltip]="
                  element?.usuario_status == 1 ? 'Ativado' : 'Desativado'
                "
                (click)="element?.usuario_status === 1 ? element.usuario_status = 2 : element.usuario_status = 1; activeEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.active_management && !spinLoad.active && element?.isUsuario === 'N'"
                [ngClass]="'disabled'"
                matTooltip="Perfil não registrado no sistema"
                [fontIcon]="'toggle_off'"
              />
              <mat-icon
                *ngIf="column.key.sendContract && !spinLoad.contract"
                class="btn-icon-outline"
                fontIcon="newspaper"
                matTooltip="Gerar Contrato"
                [ngClass]="element.statusPropostaId != 4 ? 'disabled' : ''"
                (click)="sendContractEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.sendContract && spinLoad.contract"
                diameter="24"
                matTooltip="Gerando Contrato"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.sendEmail && !spinLoad.email"
                class="btn-icon-outline"
                fontIcon="mail"
                matTooltip="Enviar email"
                [ngClass]="
                  (element.statusPropostaId && element.statusPropostaId != 4 && element.statusPropostaId != 2) || element?.usuario_status !== 1
                    ? 'disabled'
                    : ''
                "
                (click)="sendEmailEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.sendEmail && spinLoad.email"
                diameter="24"
                matTooltip="Enviando email"
              ></mat-spinner>
              <mat-icon
                *ngIf="column.key.sendEmailManagement && !spinLoad.email"
                class="btn-icon-outline"
                fontIcon="forward_to_inbox"
                matTooltip="Enviar senha para o e-mail"
                [ngClass]="
                  element?.usuario_status !== 1
                    ? 'disabled'
                    : ''
                "
                (click)="sendEmailEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.sendEmailManagement && spinLoad.email"
                diameter="24"
                matTooltip="Enviando email"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.download && !spinLoad.download"
                class="btn-icon-outline"
                fontIcon="download"
                matTooltip="Baixar"
                (click)="downloadItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.download && spinLoad.download"
                diameter="24"
                matTooltip="Enviando email"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.edit"
                class="btn-icon-outline"
                fontIcon="edit"
                matTooltip="Editar"
                (click)="selectItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.edit_management && element.isUsuario === 'S'"
                class="btn-icon-outline"
                fontIcon="edit"
                matTooltip="Editar"
                (click)="selectItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.create_management && element.isUsuario === 'N'"
                class="btn-icon-outline"
                fontIcon="add_circle"
                matTooltip="Criar usuário"
                (click)="selectItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.create_management_responsible && element.idUsuario === null"
                class="btn-icon-outline"
                fontIcon="add_circle"
                matTooltip="Criar usuário"
                (click)="selectItemEvent(element)"
              />
              <mat-icon
                *ngIf="column.key.manager"
                class="btn-icon-outline"
                fontIcon="settings"
                matTooltip="Gerenciar"
                (click)="managerItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.view"
                class="btn-icon-outline"
                fontIcon="visibility"
                matTooltip="Visualizar"
                (click)="viewItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.delete && !spinLoad.remove"
                class="btn-icon-outline"
                fontIcon="delete"
                matTooltip="Excluir"
                (click)="deleteItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.delete && spinLoad.remove"
                diameter="24"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.excel && !spinLoad.excel"
                class="btn-icon-outline"
                fontIcon="archive"
                matTooltip="Download Excel"
                (click)="excelItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.excel && spinLoad.excel"
                diameter="24"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.log && !spinLoad.log"
                class="btn-icon-outline"
                fontIcon="article"
                matTooltip="Download Log"
                (click)="logItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.log && spinLoad.log"
                diameter="24"
              ></mat-spinner>
            </div>
          }
          @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          }@else if (column.keyColumn == 'cnpj') {
            @if(listClient){
              @if(element.razaoSocial == 'PF'){
                {{ element[column.key] | cpf }}
              }@else{
                {{ element[column.key] | cnpj }}
              }
            }@else{
              {{ element[column.key] | cnpj }}
            }
          }@else if(column.keyColumn == 'corporate_name') {
            @if(listClient){
              {{ element[column.key] == 'PF' ? '-' : element[column.key]}}
            }
            @else{
              {{ element[column.key]}}
            }
          } @else if (column.keyColumn == 'location_OD') {
            <b>Origem: </b>{{ element.origem }}<br />
            <b>Destino: </b>{{ element.destino }}
          } @else if (column.keyColumn == 'servico_TS') {
            <b>Tipo: </b>{{ element.tipoServico }}<br />
            <b>Serviço: </b>{{ element.servico }}
          } @else if (column.keyColumn == 'vehicle_VM') {
            <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
            <b>Tipo motorista: </b>{{ element.tipoMotorista }}
          } @else if (column.keyColumn == 'custoExtra_HK') {
            <b>Hora: </b>{{ element.custoHoraExtra_formatado }}<br />
            <b>KM: </b>{{ element.custokmExtra_formatado }}
          } @else if (column.keyColumn == 'importDateTime') {
            {{ convertDateTimeString(element.dataImport, element.horaImport) }}
          } @else if (column.keyColumn == 'importStatus') {
            <div [ngClass]="getClass(element.statusId)">
              {{ element[column.key] }}
            </div>
          } @else if (column.keyColumn == 'importTariffCount') {
            {{ element.totalInseridos + element.totalIgnorados }} /
            {{ element.totalInseridos }} / {{ element.totalIgnorados }}
          } @else {
            {{ element[column.key] ?? '-' }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
